import { gql } from '@apollo/client';

export const TERM_PARTS_DEFINITION = gql`
  fragment TermParts on TargetingRuleDefinitionV4 {
    id
    name
    dimension
    not
    subClass
    valueSet
    rangeList {
      lower
      upper
    }
  }
`;

export const TARGETING_RULE_DEFINITION = gql`
  fragment targetingRuleDefinition on TargetingRule {
    id
    definition {
      ...TermParts
      termList {
        ...TermParts
        termList {
          ...TermParts
          termList {
            ...TermParts
            termList {
              ...TermParts
              termList {
                ...TermParts
                termList {
                  ...TermParts
                  termList {
                    ...TermParts
                    termList {
                      ...TermParts
                      termList {
                        ...TermParts
                        termList {
                          ...TermParts
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${TERM_PARTS_DEFINITION}
`;
